import { render, staticRenderFns } from "./ImagingInvestigations.vue?vue&type=template&id=2561cea9&scoped=true&"
import script from "./ImagingInvestigations.vue?vue&type=script&lang=js&"
export * from "./ImagingInvestigations.vue?vue&type=script&lang=js&"
import style0 from "./ImagingInvestigations.vue?vue&type=style&index=0&id=2561cea9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561cea9",
  null
  
)

export default component.exports